import styled from 'styled-components';

export const OverallProgressContainer = styled.div`
  padding: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  max-width: 1300px;
  margin: 0 auto;
  background-color: #fff;
  
  border-radius: 24px;
  .main-content {
    display: flex;
    gap: 40px;
    align-items: flex-start;
    width: 100%;
    

    @media (max-width: 1024px) {
      flex-direction: column;
      gap: 30px;
    }
  }

  .left-section {
    flex: 1;
    width: 100%;
  }

  @media (max-width: 768px) {
    padding: 30px 5%;
    width: 90%;
  }
`;

export const ProgressHeader = styled.div`
  margin-bottom: 40px;

  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--primary-color);
    text-transform: uppercase;
    margin: 0 0 12px 0;
    font-family: 'Inter';
  }

  .overall-progress {
    display: flex;
    align-items: center;
    gap: 16px;

    .progress-bar {
      flex: 1;
      height: 6px;
      background: #e0e0e0;
      border-radius: 4px;
      overflow: hidden;
    }

    .progress-fill {
      height: 100%;
      background: var(--primary-color);
      transition: width 0.3s ease;
    }

    .progress-percentage {
      font-size: 1rem;
      font-weight: 600;
      color: var(--primary-color);
      font-family: 'Inter';
      min-width: 80px;
      text-align: right;
    }
  }

  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 30px;

    .overall-progress {
      flex-direction: column;
      align-items: center;

      .progress-bar {
        width: 100%;
      }

      .progress-percentage {
        text-align: center;
      }
    }
  }
`;

export const CourseProgressGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  @media (max-width: 568px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  @media (max-width: 400px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const CourseProgressCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .icon-container {
    margin-bottom: 16px;

    .progress-circle {
      width: 80px;
      height: 80px;
      position: relative;

      .progress-fill {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .inner-circle {
          width: 70px;
          height: 70px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 40px;
            height: 40px;
            object-fit: contain;
          }
        }
      }
    }
  }

  .course-info {
    h3 {
      font-size: 1rem;
      font-weight: 600;
      color: #2d3748;
      margin: 0 0 4px 0;
      font-family: 'Inter';
    }

    p {
      font-size: 0.875rem;
      color: #6c757d;
      margin: 0;
      font-family: 'Inter';
    }
  }

  @media (max-width: 568px) {
    .icon-container .progress-circle {
      width: 70px;
      height: 70px;

      .progress-fill .inner-circle {
        width: 60px;
        height: 60px;

        img {
          width: 35px;
          height: 35px;
        }
      }
    }

    .course-info {
      h3 {
        font-size: 0.875rem;
      }

      p {
        font-size: 0.8125rem;
      }
    }
  }
`;

export const VideoPreviewSection = styled.div`
  flex-shrink: 0;
  width: 350px;
  background: linear-gradient(135deg, #e91e63 0%, #9c27b0 50%, #3f51b5 100%);
  padding: 14px;
  border-radius: 24px;

  .video-container {
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 16px;
  }

  .video-thumbnail {
    position: relative; /* garante que overlay e play ficam posicionados em cima */
    display: inline-block;
    width: 100%;
    height: 100%;
    cursor: pointer;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.3);
    }

    .play-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      cursor: pointer;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-50%, -50%) scale(1.1);
      }
    }
  }

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  @media (max-width: 568px) {
    width: 100%;
  }
`;


export const ContinueButton = styled.button`
  width: 100%;
  background-color: #fff;
  color: #d82e88;
  border: none;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  font-family: 'Inter';

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(233, 30, 99, 0.3);
  }

  svg {
    flex-shrink: 0;
  }

  @media (max-width: 568px) {
    font-size: 0.875rem;
    padding: 14px 20px;
  }
`;
